<template>
  <div class="wrapper">
      <div class="beta_record">
        <div class="photo_img"><img :src="headUrl"></div>
        <div class="wx_content">
          <p class="p1">{{wxName}}邀您阅读</p>
          <p class="p2">{{company}} | {{position}}</p>
        </div>
      </div>
    <div class="mobile-page-content" v-if="!loading">
        <h2 class="rich-media-title">{{ articleInfo.title }}</h2>
        <div id="meta-content" class="rich-media-meta-list">
          <span class="rich-media-meta rich-media-meta-text">{{ addtime }}</span>
          <template v-if="articleInfo.author && articleInfo.author.length>0">
            <span class="rich-media-meta rich-media-meta-text">{{ articleInfo.author }}</span>
          </template>
          <a class="rich-media-meta rich-media-meta-link rich-media-meta-nickname" href="javascript:;" @click="showPublisherCode=true">{{ articleInfo.publisher.name }}</a>
        </div>
        <div class="rich-media-content">
          <!-- 简介 -->
          <div class="rich-blue-border" v-if="articleInfo.brief.length>0">
            <p class="rich-blue-title">导读<br></p>
            <h1>测试</h1>
            <p class="rich-detail-indent">{{ articleInfo.brief }}</p>
          </div>

          <div class="rich-media-detail">
          <!-- <div class="rich-media-detail detail"> -->
            {{{ articleInfo.content }}}
          </div>

          <!-- <div class="code-ad-box">
              <div class="code-a"><img src="/static/images/code-a.jpg"></div>
              <div class="code-b"><img src="/static/images/code-b.jpg"></div>
          </div> -->

          <div class="footer-Read">
            <span class="footer-text">  阅读 {{ articleInfo.uv }}</span>
            </span>
          </div>
        </div>
    </div>

    <!--弹窗-->
    <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display:block;" v-show="showPublisherCode" @click="hideDialog($event)">
      <div class="binding-content" style="text-align:center;width: 56%; margin:45% 15%;">
        <img src="{{articleInfo.publisher.imgurl}}" alt="" width="200px" height="200px">
      </div>
    </div>
    <div class="modal-backdrop fade in" v-show="showPublisherCode"></div>
  </div>
</template>

<script>
  import {apiUrl, alert} from '../helper'
  import $ from 'jquery'
  import userMix from '../common/userMix'
  import wxshareMix from '../common/wxshareMix'

  export default {
    name: 'MyArticleDetailView',
    mixins: [userMix, wxshareMix],
    data () {
      return {
        name: '',
        id: {},
        articleInfo: {},
        addtime: '',
        showPublisherCode: false
      }
    },
    route: {
      data ({ to }) {
        console.log(to)
        this.id.id = to.params.id;
        let uid = to.query.uid;
        $.ajax({
          url: apiUrl('/V1.0.0/user/artdetail'),
          method: 'post',
          data: JSON.stringify(this.id),
          dataType: 'json'
        }).done((response) => {
          if (response.status == 0) {
            this.articleInfo = response.data;
            this.addtime = response.data.publishdate.split('T')[0];
            this.changeMetaTitle(response.data.title);
            this.getwxsign();
            this.userInfo(uid)

            // 分享描述
            let desc = ''
            if (response.data.subhead) {
              if (response.data.subhead.length>0) {
                desc = response.data.subhead
              }
            } else {
              if (response.data.brief) {
                if (response.data.brief.length>0) {
                  desc = response.data.brief
                }
              }
            }
            console.log(desc)
            this.shareArticle(response.data.title, response.data.imgurl, desc);
          }
        }).fail((response) => {
          // alert('请求失败')
          console.log(response.status)
          console.log(response.description)
        })
      }
    },
    ready () {
      this.$nextTick(function() {

        // 图片点击全屏预览
        $(document).on('click', '.mobile-page-content img', function(event) {
          var imgArray = [];
          var curImageSrc = $(this).attr('src'); // 当前图片路径
          if (curImageSrc.indexOf('http://')<0) {
            curImageSrc = window.location.origin + '/' + $(this).attr('src');
          }
          console.log(curImageSrc)


          var oParent = $(this).parent();
          if (curImageSrc && !oParent.attr('href')) {
            $('.mobile-page-content img').each(function(index, el) {
              let itemSrc = $(this).attr('src');
              if (itemSrc.indexOf('http://')<0) {
                itemSrc = window.location.origin + '/' + itemSrc;
              }
              imgArray.push(itemSrc);
            });
            console.log(imgArray)
            wx.previewImage({
              current: curImageSrc,
              urls: imgArray
            });
          }
        });

      });

    },
    methods: {
      hideDialog(e) {
        console.log(e);
        let target = $('.binding-content')
        if (!target.is(e.target) && target.has(e.target).length === 0) {
          this.showPublisherCode = false
        }
      },

      /**
       * 微信分享
       * @param  {string} fulltitle 标题
       * @param  {string} imgurl    图标
       * @param  {string} desc      描述
       */
      shareArticle(fulltitle, imgurl, desc) {
        let title = fulltitle;
        let shareLink = window.location.href;
        let shareImgLink = window.location.origin + '/' + imgurl

        this.wxSDKConfig(title, shareImgLink, shareLink, desc);
      }
    }
  }
</script>

<style scoped>
  @import "../../static/css/article.css";

  .ar-detail p {
    font-size: 14px;
    line-height: 28px;
    color: #383838;
  }

  .ar-detail .blue {
    color: #3270ad !important;
  }

  .modal {
    display: block;
  }
.mobile-page-content {
    position: relative;
    max-width: 640px;
    margin: 40px auto;
    padding: 0.8rem;
    background-color: #fff;
}
</style>



/** WEBPACK FOOTER **
 ** MyArticleDetail.vue?7f05b0dc
 **/